import React from 'react';

export interface RackChipProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** Optional hue for the leading dot — defaults to sage. */
  hue?: string;
  /** When true, renders a static span instead of a button (for use inside cards). */
  static?: boolean;
}

const RackChip: React.FC<RackChipProps> = ({
  hue,
  static: isStatic = false,
  className,
  children,
  ...rest
}) => {
  const classes = ['rr-rackchip', isStatic ? 'rr-rackchip-static' : '', className]
    .filter(Boolean)
    .join(' ');
  const dot = (
    <span
      className="rr-rackchip-dot"
      style={hue ? { background: hue } : undefined}
      aria-hidden="true"
    />
  );
  if (isStatic) {
    return (
      <span className={classes}>
        {dot}
        {children}
      </span>
    );
  }
  return (
    <button type="button" className={classes} {...rest}>
      {dot}
      {children}
    </button>
  );
};

export default RackChip;
